export default __webpack_public_path__ + "static/media/cabinet1-after-1920w.e2af1e3a.webp";